import {
  ANDROID_PACKAGE,
  APP_SCHEME,
  WEB_ONLY_PARAM
} from "routes/cashbox-approval/appHandoff";

export const PLATFORM_ANDROID = "android";
export const PLATFORM_IOS = "ios";

const customerAppPath = token => `customer-app/login-link/${token}`;

export function mobilePlatform() {
  const userAgent = navigator.userAgent.toLowerCase();

  if (/android/.test(userAgent)) {
    return PLATFORM_ANDROID;
  }

  if (/iphone|ipad|ipod/.test(userAgent)) {
    return PLATFORM_IOS;
  }

  return null;
}

export function isWebOnly() {
  return !!new URLSearchParams(window.location.search).get(WEB_ONLY_PARAM);
}

export function openAndroidApp(token) {
  const fallback = `${window.location.origin}/${customerAppPath(token)}?${WEB_ONLY_PARAM}=1`;

  window.location.href =
    `intent://${window.location.host}/${customerAppPath(token)}` +
    `#Intent;scheme=https;package=${ANDROID_PACKAGE};` +
    `S.browser_fallback_url=${encodeURIComponent(fallback)};end`;
}

export function openIOSApp(token) {
  window.location.assign(`${APP_SCHEME}://${customerAppPath(token)}`);
}
